import { restApi } from '../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'

const slaRepository = createRepository({
  path: 'sla',
  restApi
})

slaRepository.temposFila = (dataInicio, dataFim, geral, empresaId) => {
  return restApi.get(`sla/solicitacoes-aberto-mean-max`, {
    dataInicio,
    dataFim,
    geral,
    empresaId
  })
}

slaRepository.temposAnalise = (dataInicio, dataFim, geral, empresaId) => {
  return restApi.get(`sla/solicitacoes-analise-mean-max`, {
    dataInicio,
    dataFim,
    geral,
    empresaId
  })
}

slaRepository.temposFilaAtual = params => {
  return restApi.get(`sla/solicitacoes-aberto-atual-mean-max`, params)
}

slaRepository.temposAnaliseAtual = params => {
  return restApi.get(`sla/solicitacoes-analise-atual-mean-max`, params)
}

slaRepository.solicitacoesTotal = (dataInicio, dataFim, empresaId) => {
  return restApi.get(`sla/solicitacoes-total`, {
    dataInicio,
    dataFim,
    empresaId
  })
}

slaRepository.filaAtual = params => {
  return restApi.get('sla/solicitacoes-aberto-atual', params)
}

slaRepository.analiseAtual = params => {
  return restApi.get('sla/solicitacoes-analise-atual', params)
}

slaRepository.pendenteAtual = params => {
  return restApi.get('sla/solicitacoes-pendente-atual', params)
}

slaRepository.liberadaComPendenciaAtual = params => {
  return restApi.get('sla/solicitacoes-liberada-pendencia-atual', params)
}

slaRepository.pendenteGestorAtual = params => {
  return restApi.get('sla/solicitacoes-pendente-gestor-atual', params)
}

slaRepository.tempoPorAnalista = (dataInicio, dataFim, empresaId) => {
  return restApi.get(`sla/solicitacoes-mean-max-por-analista`, {
    dataInicio,
    dataFim,
    empresaId
  })
}

slaRepository.solicitacoesPorAnalista = (dataInicio, dataFim, empresaId) => {
  return restApi.get(`sla/solicitacoes-por-analista`, {
    dataInicio,
    dataFim,
    empresaId
  })
}

slaRepository.metasSolicitacoesPorAnalista = (
  dataInicio,
  dataFim,
  empresaId
) => {
  return restApi.get(`sla/metas-solicitacoes-por-analista`, {
    dataInicio,
    dataFim,
    empresaId
  })
}

slaRepository.tempoPorUnidade = (dataInicio, dataFim, empresaId) => {
  return restApi.get(`sla/solicitacoes-mean-max-por-unidade`, {
    dataInicio,
    dataFim,
    empresaId
  })
}

slaRepository.solicitacoesPorUnidade = (dataInicio, dataFim, empresaId) => {
  return restApi.get(`sla/solicitacoes-por-unidade`, {
    dataInicio,
    dataFim,
    empresaId
  })
}

slaRepository.metasSolicitacoesPorUnidade = (dataInicio, dataFim) => {
  return restApi.get(`sla/metas-solicitacoes-por-unidade`, {
    dataInicio,
    dataFim
  })
}

slaRepository.solicitacoesPorHora = (dataInicio, dataFim, empresaId) => {
  return restApi.get(`sla/solicitacoes-por-hora`, {
    dataInicio,
    dataFim,
    empresaId
  })
}

slaRepository.solicitacoesFinalizadasPorHora = (
  dataInicio,
  dataFim,
  empresaId
) => {
  return restApi.get(`/sla/solicitacoes-finalizadas-por-hora`, {
    dataInicio,
    dataFim,
    empresaId
  })
}

slaRepository.findTemposOciosos = (dataInicio, dataFim) => {
  return restApi.get('sla/tempos-ociosos-analistas', { dataInicio, dataFim })
}

slaRepository.logSolicitacaoTempoStatus = solicitacaoId => {
  return restApi.get(`/sla/log-solicitacao-tempo-status/${solicitacaoId}`)
}

slaRepository.logSolicitacaoTempoAnalisePorAnalista = solicitacaoId => {
  return restApi.get(
    `/sla/log-solicitacao-tempo-analise-por-analista/${solicitacaoId}`
  )
}

export default slaRepository
